import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import { MaxCount } from "./common";

interface Props {
  typeName: string;
}

export const SelectEdProps: React.FC<Props> = ({ typeName }) =>
  typeName === AttrTypeName.dictMulti ? <MaxCount /> : null;
